import { AlertType } from '../../enums/AlertType';
import { Alert } from '../../interfaces/Alert';

export const ALERT_POST_UPDATED: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'custom.post_updated',
    translate: true,
  },
  time: 2000,
};
